import React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { FormItemProps } from 'antd/lib/form';
import { Form, InputNumber } from 'antd';
import { InputNumberProps } from 'antd/lib/input-number';

type FormNumberInputProps = WrappedFieldProps & FormItemProps & InputNumberProps;

export const FormNumberInput = ({
  name,
  label,
  required,
  validateStatus,
  labelCol,
  wrapperCol,
  meta,
  input,
  ...rest
}: FormNumberInputProps) => {
  const errorMessage = !!meta && meta.error;
  const showError = !!meta && meta.touched && !!meta.error;
  const { onBlur, onChange, ...restInput } = input;

  const handleChange = (value: number | string | undefined) => {
    onChange(value);
  };

  return (
    <Form.Item
      label={label}
      required={required}
      validateStatus={showError ? 'error' : undefined}
      help={showError ? errorMessage : undefined}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <InputNumber onChange={handleChange} {...restInput} {...rest} />
    </Form.Item>
  );
};
